import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (this.noActiveItemSet) {
      // @ts-expect-error TS2345 violates strict null checks
      this.activateItem(this.firstItemKey);
    }
  }

  get firstItemKey() {
    // @ts-expect-error TS2531 violates strict null checks
    return this.firstItemTab.getAttribute('data-key');
  }

  get firstItemTab() {
    return this.element.querySelector('.sc-TabNavCard-itemTab');
  }

  get activeItemTab() {
    return this.element.querySelector('.sc-TabNavCard-itemTab.is-active');
  }

  get activeItemContent() {
    return this.element.querySelector('.sc-TabNavCard-itemContent.is-active');
  }

  get noActiveItemSet() {
    return !this.activeItemTab;
  }

  clickItemTab(event: MouseEvent) {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const newlyActiveItemKey = target.getAttribute('data-key');

    this.deactivateActiveItem();
    // @ts-expect-error TS2345 violates strict null checks
    this.activateItem(newlyActiveItemKey);
    this.triggerChangeEvent();
  }

  triggerChangeEvent() {
    const event = new Event('change');
    this.element.dispatchEvent(event);
  }

  deactivateActiveItem() {
    // @ts-expect-error TS2531 violates strict null checks
    this.activeItemTab.classList.remove('is-active');
    // @ts-expect-error TS2531 violates strict null checks
    this.activeItemContent.classList.remove('is-active');
  }

  activateItem(key: string) {
    const newlyActiveItemTab = this.element.querySelector(`.sc-TabNavCard-itemTab[data-key="${key}"]`);
    const newlyActiveItemContent = this.element.querySelector(`.sc-TabNavCard-itemContent[data-key="${key}"]`);
    // @ts-expect-error TS18047 violates strict null checks
    newlyActiveItemTab.classList.add('is-active');
    // @ts-expect-error TS18047 violates strict null checks
    newlyActiveItemContent.classList.add('is-active');
  }
}
